import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import { useInvestor } from '../hooks';
import useIsFullLiquidation from '../hooks/useIsFullLiquidation';
import useIsModelSwitching from '../hooks/useIsModelSwitching';
import InvestmentStatusBanner from '../Investments/InvestmentStatusBanner';
import { InvestingBannerStatus } from '../Investments/InvestmentStatusBanner/InvestmentStatusBanner';

import { useGetInvestorAccountId } from './hook';


const InvestmentsSwitchBanner = () => {
  const accountId = useGetInvestorAccountId();
  const { isFullLiquidated, } = useIsFullLiquidation({ accountId });
  const isModelSwitching = useIsModelSwitching(accountId);
  const {
    data: { type: modelType },
  } = useInvestor(accountId);
  const currentBannerStatus = useMemo(() => {
    if (isModelSwitching) {
      return InvestingBannerStatus.Switching;
    }
    if (isFullLiquidated) {
      return InvestingBannerStatus.Reactivate;
    }

    return InvestingBannerStatus.Pending;
  }, [isFullLiquidated, isModelSwitching]);
  return (
    <Box>
      <InvestmentStatusBanner accountId={accountId} modelType={modelType} status={currentBannerStatus} />
    </Box>
  );
};
export default InvestmentsSwitchBanner;
